import type { Company } from '../../types';
import type { CompanyListResponse } from './api';

export const normalizeCompanyList = (list: CompanyListResponse): Company[] => {
  if (!list) {
    return [];
  }
  return list.toSorted((a, b) => {
    const companyNameA = a.companyName.toLowerCase();
    const companyNameB = b.companyName.toLowerCase();

    if (companyNameA < companyNameB) {
      return -1;
    }
    if (companyNameA > companyNameB) {
      return 1;
    }
    return 0;
  });
};
